const API_URL = process.env.REACT_APP_API_URL

const apiUrl = path => `${API_URL}${path}`;

export { API_URL, apiUrl }